import React from 'react';
import StaticPageLayout from './StaticPageLayout';
import {
  ABOUT_PAGE_SECTIONS,
  COMPANY_LEGAL_NAME,
  COMPANY_REGISTRATION_NUMBER,
  TRUST_PAGES_LAST_UPDATED,
} from '../../constants/siteTrustContent';

const AboutPage = () => {
  return (
    <StaticPageLayout title="About Zoomed In">
      <p className="static-page__muted">Last updated: {TRUST_PAGES_LAST_UPDATED}</p>
      {ABOUT_PAGE_SECTIONS.map((section) => (
        <React.Fragment key={section.heading}>
          <h3>{section.heading}</h3>
          {section.paragraphs.map((paragraph, index) => (
            <p key={`${section.heading}-${index}`}>{paragraph}</p>
          ))}
        </React.Fragment>
      ))}
      <h3>Company Details</h3>
      <p>
        Zoomed In is developed by <strong>{COMPANY_LEGAL_NAME}</strong>{' '}
        (<strong>Registration No.</strong> {COMPANY_REGISTRATION_NUMBER}).
      </p>
      <p className="static-page__muted">
        For legal, support, or policy questions, please use the Contact page.
      </p>
    </StaticPageLayout>
  );
};

export default AboutPage;

